import axios from 'axios';
import { helperGetApiHeaders, helperGetApiRoute } from 'helpers/ApiHelper';

export const FETCH_BROWSE = 'FETCH_BROWSE';
export const FETCH_NEXT = 'FETCH_NEXT';
export const RESET = 'RESET';
export const SELECT_TAB = 'SELECT_TAB';
export const SET_FETCHING = 'SET_FETCHING';

export const fetchBrowse = ({ accessToken, deviceId } = {}) => {
  const pageType = 'browse';
  const headers = helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId });
  const fetchUrl = helperGetApiRoute(pageType);

  const request = axios.get(fetchUrl, headers);

  return {
    type: FETCH_BROWSE,
    payload: request,
  };
};

export const fetchNextPage = async ({ accessToken, deviceId, nextUrl, filterName = '' } = {}) => {
  const pageType = 'browse';
  if (nextUrl) {
    const headers = helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId });

    const result = await axios.get(nextUrl, headers);
    return {
      type: FETCH_NEXT,
      payload: { data: { ...(result?.data ?? {}), filterName } },
    };
  }
  return { type: FETCH_NEXT };
};

export const selectTab = filter => ({
  type: SELECT_TAB,
  payload: filter,
});

export const resetBrowse = () => ({
  type: RESET,
});

export const setFetching = value => ({
  type: SET_FETCHING,
  payload: value,
});
